import React, { Suspense } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { CONDICAO_UNICA_PREFIX_PATH } from "configs/AppConfig";

const HomeLazy = lazyComReload(() => import("./home"));

export const CondicaoUnicaViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route path={`${CONDICAO_UNICA_PREFIX_PATH}`} component={HomeLazy} />
			</Switch>
		</Suspense>
	);
};

export default CondicaoUnicaViews;
